import { render } from "./form-kpi.vue?vue&type=template&id=d369f194&scoped=true"
import script from "./form-kpi.vue?vue&type=script&lang=js"
export * from "./form-kpi.vue?vue&type=script&lang=js"

import "./form-kpi.vue?vue&type=style&index=0&id=d369f194&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d369f194"

export default script